import { render, staticRenderFns } from "./DspTagListFooter.vue?vue&type=template&id=fd9af63e"
import script from "./DspTagListFooter.vue?vue&type=script&lang=js"
export * from "./DspTagListFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports